/**
 * ListSizeChanger
 */

import DropdownLayer from '../DropdownLayer';
import Config from '../Config';
import Util from '../Util';

class ListSizeChanger {

	public onChange: any;

	public onInit: any;

	public dropdownLayer: any;

	private $parent: any;

	private value: number;

	private isSetDefault: boolean;

	private item: any[];

	constructor( $parent: any, value: number, isSetDefault = false ) {
		this.$parent = $parent;
		this.value = value;
		this.isSetDefault = isSetDefault;
		this.onChange = new Util.Observer();
		this.onInit = new Util.Observer();
		// this.onNull = new Observer;

		const countText = Config.L10N.count;

		this.item = [
			{ key: 20, value: `20${countText}` },
			{ key: 30, value: `30${countText}` },
			{ key: 50, value: `50${countText}` },
		];

		this.setUI();
	}

	public setValue( val: number ) {
		this.dropdownLayer.setValue( val );
	}

	public setUI( data?: any ) {
		let _item;

		this.dropdownLayer = new DropdownLayer( this.$parent, this.item, 'boardSize', 'board-size' );
		this.dropdownLayer.addChange( ( chgData: any ) => {

			if ( chgData ) {
				this.onChange.emit( chgData );
			}

		});

		if ( this.isSetDefault ) {
			_item = this.item[ 0 ].key;
			this.setValue( _item );
		} else if ( this.value ) {
			_item = this.value;
			this.setValue( _item );
		}

		this.onInit.emit( _item );

		// this.$parent.prepend( this.dropdownLayer.getNode() );
	}

}

export default ListSizeChanger;
